export default function CensusUploadIcon () {
  return (
    <svg
      width={224}
      height={152}
      className='max-w-full'
      viewBox='0 0 224 152'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10 4C6.68629 4 4 6.68629 4 10V13C4 14.1046 3.10457 15 2 15C0.895431 15 0 14.1046 0 13V10C0 4.47715 4.47715 0 10 0H13C14.1046 0 15 0.895431 15 2C15 3.10457 14.1046 4 13 4H10Z'
        fill='#757575'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M214 4C217.314 4 220 6.68629 220 10V13C220 14.1046 220.895 15 222 15C223.105 15 224 14.1046 224 13V10C224 4.47715 219.523 0 214 0H211C209.895 0 209 0.895431 209 2C209 3.10457 209.895 4 211 4H214Z'
        fill='#757575'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10 148C6.68629 148 4 145.314 4 142V139C4 137.895 3.10457 137 2 137C0.895431 137 0 137.895 0 139V142C0 147.523 4.47715 152 10 152H13C14.1046 152 15 151.105 15 150C15 148.895 14.1046 148 13 148H10Z'
        fill='#757575'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M214 148C217.314 148 220 145.314 220 142V139C220 137.895 220.895 137 222 137C223.105 137 224 137.895 224 139V142C224 147.523 219.523 152 214 152H211C209.895 152 209 151.105 209 150C209 148.895 209.895 148 211 148H214Z'
        fill='#757575'
      />
      <line
        x1={20}
        y1={1}
        x2={204}
        y2={1}
        stroke='#D9D9D9'
        strokeWidth={2}
        strokeLinecap='round'
        strokeDasharray='0.01 8'
      />
      <line
        x1={20}
        y1={150}
        x2={204}
        y2={150}
        stroke='#D9D9D9'
        strokeWidth={2}
        strokeLinecap='round'
        strokeDasharray='0.01 8'
      />
      <line
        x1={2}
        y1={132}
        x2={2}
        y2={20}
        stroke='#D9D9D9'
        strokeWidth={2}
        strokeLinecap='round'
        strokeDasharray='0.01 8'
      />
      <line
        x1={222}
        y1={132}
        x2={222}
        y2={20}
        stroke='#D9D9D9'
        strokeWidth={2}
        strokeLinecap='round'
        strokeDasharray='0.01 8'
      />
      <g filter='url(#filter0_dd_764_25748)'>
        <rect
          x={14}
          y={15}
          width={195}
          height={122}
          rx={4}
          fill='white'
          shapeRendering='crispEdges'
        />
        <rect
          x={14.5}
          y={15.5}
          width={194}
          height={121}
          rx={3.5}
          stroke='#D9D9D9'
          shapeRendering='crispEdges'
        />
        <rect x={30} y={31} width={35} height={10} rx={2} fill='#E5E5E5' />
        <rect x={77} y={31} width={61} height={10} rx={2} fill='#E5E5E5' />
        <rect x={148} y={31} width={45} height={10} rx={2} fill='#E5E5E5' />
        <rect x={30} y={75} width={35} height={10} rx={2} fill='#E5E5E5' />
        <rect x={77} y={75} width={51} height={10} rx={2} fill='#E5E5E5' />
        <rect x={158} y={75} width={35} height={10} rx={2} fill='#E5E5E5' />
        <rect x={30} y={57} width={35} height={10} rx={2} fill='#E5E5E5' />
        <rect x={77} y={57} width={51} height={10} rx={2} fill='#E5E5E5' />
        <rect x={158} y={57} width={35} height={10} rx={2} fill='#E5E5E5' />
        <rect x={30} y={93} width={35} height={10} rx={2} fill='#E5E5E5' />
        <rect x={30} y={111} width={35} height={10} rx={2} fill='#E5E5E5' />
        <rect x={77} y={93} width={51} height={10} rx={2} fill='#E5E5E5' />
        <rect x={77} y={111} width={51} height={10} rx={2} fill='#E5E5E5' />
        <rect x={158} y={93} width={35} height={10} rx={2} fill='#E5E5E5' />
        <rect x={158} y={111} width={35} height={10} rx={2} fill='#E5E5E5' />
        <line x1={30} y1={48.5} x2={193} y2={48.5} stroke='#D9D9D9' />
      </g>
      <defs>
        <filter
          id='filter0_dd_764_25748'
          x={10}
          y={12}
          width={203}
          height={130}
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity={0} result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.0470588 0 0 0 0 0.0470588 0 0 0 0 0.0509804 0 0 0 0.05 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_764_25748'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.0470588 0 0 0 0 0.0470588 0 0 0 0 0.0509804 0 0 0 0.1 0'
          />
          <feBlend
            mode='normal'
            in2='effect1_dropShadow_764_25748'
            result='effect2_dropShadow_764_25748'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect2_dropShadow_764_25748'
            result='shape'
          />
        </filter>
      </defs>
    </svg>
  )
}
